<template>
  <div style="display: inline-block;">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 384.8 384.8"
    >
      <g>
        <path
          :fill="iconColor"
          d="M201.3,0.7c7,1.2,14,2.1,20.9,3.8c49.6,12,86.9,53.9,92.7,104.7c4.5,39.3-7.3,73.5-35,101.7
          c-14.6,14.9-25.5,31.6-29.5,52.2c-1.2,6.3-1.8,12.9-1.9,19.3c-0.3,15,0,29.9-0.1,44.9c-0.1,29.7-21.6,53.4-51.1,56.6
          c-27.8,2.9-54-16.5-60-44.7c-0.8-3.9-1.1-7.9-1.2-11.9c-0.1-14.8,0-29.7-0.1-44.5c-0.1-26.7-9.5-49.7-28.5-68.5
          C87.4,194,74.4,170.3,70,141.9C62.4,92.7,87.2,41.6,130.6,17.1c15.4-8.7,31.9-14,49.5-15.8c0.8-0.1,1.7-0.4,2.5-0.6
          C188.8,0.7,195,0.7,201.3,0.7z M225.9,270c2-8.3,3.5-16.4,5.9-24.2c6.3-20.4,18.6-36.8,33.3-52c25.1-26.1,33.7-57.7,25.5-92.8
          C278.2,48.2,229.5,16,175.6,24.6c-56.5,9-93.4,62.2-82.5,119.1c4,20.8,14.1,38.4,29.3,53.2c13.6,13.3,23.9,28.8,29.8,46.9
          c2.8,8.5,4.4,17.3,6.6,26.1C181.1,270,203.7,270,225.9,270z M158.6,292.8c0,12.3-0.2,24.2,0,36c0.3,17.1,14.1,31.4,31.1,32.6
          c17.2,1.2,33.2-10.6,35.4-27.6c1.4-10.7,0.6-21.6,0.8-32.5c0-2.8,0-5.6,0-8.5C203.3,292.8,181.2,292.8,158.6,292.8z"
        />
        <path
          :fill="iconColor"
          d="M384,135.5c-15.1,0-30.1,0-45.4,0c0-7.5,0-14.7,0-22.5c15.1,0,30.3,0,45.4,0C384,120.5,384,128,384,135.5z"
        />
        <path
          :fill="iconColor"
          d="M28.3,35.1C39,45.7,49.9,56.6,60.5,67.3c-4.9,4.9-10.1,10.1-15.1,15.1C34.8,71.7,24,60.8,13.3,50.1
          C18.3,45.2,23.4,40,28.3,35.1z"
        />
        <path
          :fill="iconColor"
          d="M324,67.1c10.7-10.6,21.5-21.4,32.1-32c5,5,10.1,10.1,15.1,15.1c-10.6,10.5-21.5,21.4-32.3,32.1
          C334.1,77.4,329,72.2,324,67.1z"
        />
        <path
          :fill="iconColor"
          d="M13.4,198c10.8-10.8,21.6-21.6,32.1-32c5,5,10.1,10.2,15,15.1c-10.4,10.4-21.3,21.3-32,32
          C23.6,208.2,18.4,203,13.4,198z"
        />
        <path
          :fill="iconColor"
          d="M355.8,213.3c-10.6-10.6-21.5-21.4-32-31.9c5.1-5.1,10.2-10.2,15.2-15.2c10.4,10.4,21.2,21.3,31.9,32.1
          C366,203.1,360.9,208.3,355.8,213.3z"
        />
        <path
          :fill="iconColor"
          d="M0.8,113.1c15.1,0,30,0,45.2,0c0,7.3,0,14.6,0,22.1c-15,0-30,0-45.2,0C0.8,127.9,0.8,120.8,0.8,113.1z"
        />
        <path
          :fill="iconColor"
          d="M203.5,157.7c-7.7,0-14.9,0-22.1,0c-2-18.7,2-35,17.6-47c4.7-3.6,5.8-9.1,3.2-14c-2.3-4.5-7.5-7-12.2-5.9
          c-5.4,1.2-8.9,5.6-9,11.4c-0.1,3.5,0,6.9,0,10.6c-7.5,0-14.8,0-22.2,0c-1.4-14.5,0.3-27.8,12.6-37.4c14.3-11.2,34.6-9.2,46.4,4.6
          c11.8,13.9,10.9,34.9-3.2,46.7c-8.4,7-12.2,15-11.2,25.7C203.7,154,203.5,155.7,203.5,157.7z"
        />
        <path
          :fill="iconColor"
          d="M203.4,180.5c0,7.4,0,14.6,0,22c-7.4,0-14.6,0-22.1,0c0-7.3,0-14.6,0-22C188.6,180.5,195.8,180.5,203.4,180.5z"
        />
      </g>
    </svg>
  </div>
</template>

<script>
import { globals } from "@/mixins/globals";

export default {
  name: "QuizZoneIcon",
  mixins: [globals],
  props: {
    size: {
      type: [String, Number],
      default: 30
    },
    color: {
      type: String,
      default: null
    },
    bgColor: {
      type: String,
      default: null
    }
  },
  computed: {
    isDescriptionColour() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDescriptionColour
      ) {
        return this.$store.state.sdkEvent.isDescriptionColour;
      }
      return null;
    },
    shadowBgColor() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.shadowBgColor;
      }
      return null;
    },
    isDarkTheme() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return false;
    },
    iconColor() {
      const baseColor = this.color || this.isDescriptionColour || this.bgTheme || '#585957';
      const background = this.bgColor || this.shadowBgColor;

      if (this.isDarkTheme && background && this.areColorsSimilar(baseColor, background)) {
        return this.lightenColor(baseColor, 40);
      }
      return baseColor;
    }
  },
  methods: {
    hexToRgb(hex) {
      if (!hex) return null;
      hex = hex.replace('#', '');
      if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      return { r, g, b };
    },
    areColorsSimilar(color1, color2, threshold = 60) {
      const rgb1 = this.hexToRgb(color1);
      const rgb2 = this.hexToRgb(color2);
      if (!rgb1 || !rgb2) return false;

      const distance = Math.sqrt(
        Math.pow(rgb1.r - rgb2.r, 2) +
        Math.pow(rgb1.g - rgb2.g, 2) +
        Math.pow(rgb1.b - rgb2.b, 2)
      );
      return distance < threshold;
    },
    lightenColor(hex, percent) {
      const rgb = this.hexToRgb(hex);
      if (!rgb) return hex;

      const r = Math.min(255, Math.floor(rgb.r + (255 - rgb.r) * (percent / 100)));
      const g = Math.min(255, Math.floor(rgb.g + (255 - rgb.g) * (percent / 100)));
      const b = Math.min(255, Math.floor(rgb.b + (255 - rgb.b) * (percent / 100)));

      return '#' + [r, g, b].map(x => x.toString(16).padStart(2, '0')).join('');
    }
  }
};
</script>
